import axios from 'axios';
import { getDeviceFingerprint } from '../utils/deviceFingerprint';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1/';

export const getOrCreateGuestUuid = () => {
  let uuid = localStorage.getItem('yooki_guest_uuid');
  if (!uuid) {
    uuid = 'guest_' + Math.random().toString(36).substring(2, 15) + '_' + Date.now().toString(36);
    localStorage.setItem('yooki_guest_uuid', uuid);
  }
  return uuid;
};

export const initGuestSession = async (preferredName = null, is18Plus = true) => {
  const guestUuid = getOrCreateGuestUuid();
  const fingerprint = getDeviceFingerprint();
  try {
    const response = await axios.post(`${API_BASE}guest/init`, {
      guest_uuid: guestUuid,
      preferred_name: preferredName,
      device_fingerprint: fingerprint,
      is_18_plus: is18Plus
    });
    return response.data;
  } catch (error) {
    console.error('Error initializing guest session:', error);
    return {
      guest_uuid: guestUuid,
      preferred_name: preferredName,
      chat_count: 0,
      max_free_chats: 2,
      limit_reached: false
    };
  }
};

export const sendGuestChat = async (message) => {
  const guestUuid = getOrCreateGuestUuid();
  const fingerprint = getDeviceFingerprint();
  try {
    const response = await axios.post(`${API_BASE}guest/chat`, {
      guest_uuid: guestUuid,
      message,
      device_fingerprint: fingerprint
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 403) {
      return {
        limit_reached: true,
        reply: "You have used your 2 free guest previews. Please sign in to continue."
      };
    }
    throw error;
  }
};

export const getTodayCurrentAffairs = async () => {
  try {
    const response = await axios.get(`${API_BASE}guest/current-affairs/today`);
    return response.data;
  } catch (error) {
    console.error("Error fetching today's current affairs:", error);
    return [];
  }
};
